import { render } from "./FormName.vue?vue&type=template&id=71b2f7da&scoped=true&ts=true"
import script from "./FormName.vue?vue&type=script&lang=ts"
export * from "./FormName.vue?vue&type=script&lang=ts"

import "./FormName.vue?vue&type=style&index=0&id=71b2f7da&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b2f7da"]])

export default __exports__